<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <template v-if="limitReached">
        {{ $t('automationUsageThresholdNotification.limitReachedBody') }}
      </template>
      <template v-else>
        {{
          $t('automationUsageThresholdNotification.warningBody', {
            threshold: notification.data.threshold,
          })
        }}
      </template>
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'AutomationUsageThresholdNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  computed: {
    limitReached() {
      return this.notification.data.threshold >= 100
    },
  },
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
